<dx-data-grid #transports biz-grid [dataSource]='locations()' [selection]='{ mode: singlePartner() ? "single" : "multiple" }' [bizSetPager]="false"
    (bizOnToolbarPreparing)="onToolbarPreparing($event)" (onRowDblClick)="onRowDblClick($event)" (onSelectionChanged)="onSelectionChanged($event)">

    <dxo-editing [allowAdding]="allowAdding()" [allowUpdating]="allowViewing()" [allowDeleting]="allowDeleting()"></dxo-editing>

    @if (showBlockedColumn()) {
        <dxi-column dataField="BlockedByImport" caption="Blocked" dataType="boolean" allowFiltering="true"></dxi-column>
    }

    <dxi-column dataField="Name" dataType="string" sortOrder="asc"></dxi-column>

    @if (!singlePartner())
    {
        <dxi-column dataField="PartnerId" caption="Partner" dataType="string" cellTemplate="partnerNameLink">
            <dxo-lookup [dataSource]="partners()" valueExpr="PartnersId" displayExpr="PartnerName"></dxo-lookup>
            <ng-container *dxTemplate="let cellInfo of 'partnerNameLink'">
                @if (cellInfo.data.PartnerId)
                {
                <a [routerLink]="['/partner/details', {partnerIds: cellInfo.data.PartnerId, showTransportConfiguration: true}]">
                    {{getPartnerName(cellInfo)}}
                </a>
                }
            </ng-container>
        </dxi-column>

        <dxi-column caption="Global" [calculateCellValue]="isGlobal" dataType="boolean" allowFiltering="true"></dxi-column>
    }

    <dxi-column dataField="TransportTypeId" caption="Transport Type" dataType="string">
        <dxo-lookup [dataSource]="transportTypes()" valueExpr="Id" displayExpr="Name"></dxo-lookup>
    </dxi-column>

    <dxi-column dataField="DisplayAddress" caption="Address" dataType="string"></dxi-column>

    <dxi-column dataField="PartnerSystemId" caption="Partner System" dataType="string">
        <dxo-lookup [dataSource]="partnerSystems()" valueExpr="Id" displayExpr="Name"></dxo-lookup>
    </dxi-column>

    <dxi-column dataField="MonitorItem.currentStatus.EffectiveStatus" caption="Monitor status" cellTemplate="statusTemplate" alignment="center">
        <ng-container *dxTemplate="let data of 'statusTemplate'">
            <app-status-traffic-light [status]="data.value"></app-status-traffic-light>
        </ng-container>
    </dxi-column>

    <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(locations(), 'CreatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
    <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(locations(), 'UpdatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

    <dxi-column type="buttons" [fixed]="true" [width]="201" fixedPosition="right">
        <dxi-button name="edit" text="Details" [onClick]="onLocationView"></dxi-button>
        <dxi-button name="copy" text="Copy" [visible]="checkAllowCopying" [onClick]="onLocationCopy"></dxi-button>
        <dxi-button name="delete" [visible]="checkAllowDeleting" [onClick]="onLocationDelete"></dxi-button>
        <dxi-button name="Show Log" template="logTemplate" [visible]="allowShowLog"></dxi-button>
    </dxi-column>

    <ng-container *dxTemplate="let cell of 'logTemplate'">
        <app-change-log-link *bizPermissionRequired="'Transport_View_OutgoingLocation_Log'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="TransportOutConfiguration" [id]="cell.data.Id"></app-change-log-link-entity>
        </app-change-log-link>
    </ng-container>
</dx-data-grid>
